import QuotaExceededModal from './QuotaExceededModal.vue';

export default QuotaExceededModal;
